import { defineStore } from "pinia";
import { commClient } from "fw4-library";
import router from "@/app/router";
import { useFw4Store, IFileData, MessageBoxPredefinedButtons, MessageBoxButtonType } from "fw4-library";
import { useContractCreateStore } from "./contract-create-store";

export enum EmploymentType{
    zap = 'Z',
    upo = 'U',
    sp = 'SP'
    // 0 = zaposlen, 1 = upokojenec, 2 = S.P.
}

export interface IKeyValue{
    Key: number | string;
    Value: number | string;
    AdditionalData?: Record<string, any>
}

export interface IPersonalData {
    Cookies: ICookies;
    GoogleAnalytics: boolean;
}

export interface IDataHelpers {
    ContractSaveClicked: boolean;
    ServerError: string;
    CodeSent: boolean;
    FinancialDataConfirmed: boolean;
    IsTaxNumberLocked: boolean;
    Pay3: boolean;
    DocumentationNeeded: boolean;
    IsSuperFast: boolean;
    DisableButton: boolean;
    HideSummary: boolean;
    ShowConfirmData: boolean;
    ShowNavigation: boolean | null;
    ShowCookies: boolean;
    ShowMore: boolean;
    CloseTab: boolean;
    ShowPermanentValidity: boolean;
}

export enum ICookies {
    all = "all",
    some = "some",
    none = "none",
    analytics = "analytics",
}

// STATE
export interface IAppState{
    CountryPhoneList: IKeyValue[];
    PostalCodeList: IKeyValue[];        
    PersonalData: IPersonalData;
    DataHelpers: IDataHelpers;
    ShowLoaderMain: boolean;
}

export const useAppStore = defineStore('appStore', {
    state: (): IAppState => {
        return {
            CountryPhoneList: [],
            PostalCodeList: [],
            PersonalData: {
                Cookies: ICookies.all,
                GoogleAnalytics: false
            },
            DataHelpers: {
                ServerError: "",
                ContractSaveClicked: false,
                CodeSent: false,
                FinancialDataConfirmed: false,
                IsTaxNumberLocked: false,
                Pay3: false,
                DocumentationNeeded: false,
                IsSuperFast: false,
                DisableButton: false,
                HideSummary: false,
                ShowConfirmData: true,
                ShowNavigation: null,
                ShowCookies: false,
                ShowMore: false,
                CloseTab: false,
                ShowPermanentValidity: false
            },
            ShowLoaderMain: false
        }
    },
    actions: {

        async choseCountryPhone() {
            const loadComplete = (Message: any): void => {
                if (Message) {
                    this.CountryPhoneList = Message as IKeyValue[];
                }
            };

            commClient.executeMethod("sf.CountryPhoneList", {}, loadComplete);
        },     

        CheckDavcna (numDavcna: number) {
            let davcna = numDavcna.toString();
            //preveri ali je številka
            if (!/^\d+$/.test(davcna))
                return false;    
            if (davcna[0] != "0") {
                if (davcna.length == 8) {
                    var contr = parseInt(davcna[0]) * 8 +
                        parseInt(davcna[1]) * 7 +
                        parseInt(davcna[2]) * 6 +
                        parseInt(davcna[3]) * 5 +
                        parseInt(davcna[4]) * 4 +
                        parseInt(davcna[5]) * 3 +
                        parseInt(davcna[6]) * 2;
                    contr = contr % 11;
                    contr = (11 - contr) % 10;
                    if (parseInt(davcna[7]) == contr) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;          
            }
        },

        CancelProcedure() {
            const fw4 = useFw4Store();
            const contractCreateStore = useContractCreateStore();
            this.DataHelpers.CloseTab = true;

            fw4.ShowMessageBox("Prekinitev postopka", "Ste prepričani, da želite prekiniti postopek sklenitve plačila na obroke?", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel],
                MessageBoxPredefinedButtons[MessageBoxButtonType.OK]
                ]).then((buttonId: any) => {  
                    
                    if (buttonId == "OK") {
                        // this.CancelProcedureAccept();
                        if(contractCreateStore.AppState.WebOrderData.errorPage != ''){
                            // this.DataHelpers.CloseTab = true;
                            window.location.href = contractCreateStore.AppState.WebOrderData.errorPage;
                        }else{
                            // this.DataHelpers.CloseTab = true;
                            this.CancelProcedureAccept();
                        }
                    }
                })
        },

        //cancel procedure
        CancelProcedureAccept(){
            //razmisli ali ga diskonektamo, potem ko bomo naredili vse drugo in potestiram
            if(commClient.WebSocketConnected){
                this.userLogOut();
                commClient.disconnectWebSockets();
            }
    
            router.push({name: 'prekinitev_postopka', params: {id: router.currentRoute.value.params.id}})
        },
        //go to link in new tab
        ToLinkNewTab(url: string){
            window.open(url, '_blank');
        },

        //modal cookies
        CookiesClearAndClose(){
            this.DataHelpers.ShowCookies = false;
        },
        
        CookiesBack(){
            this.DataHelpers.ShowMore = false;
        },
        // TrackPageWebFlow(){
        //     if(import.meta.env.MODE != "PROD"){
        //         ScarabQueue.push(['testMode']);
        //     }

        //     if(this.PersonalData.TaxNumber){
        //         ScarabQueue.push(['setCustomerId', this.PersonalData.TaxNumber.toString()]);
        //         ScarabQueue.push(['tag', 'content_pageview', { content_url: window.location.href, content_title: router.currentRoute.value.name as string }]);
        //         ScarabQueue.push(['go']);
        //     }
        // },

        async userLogOut() {
            const logoutComplete = (Message: any): void => {
            };

            commClient.executeMethod("LogOut",
                {

                },
            logoutComplete);
        },
    }
});